Date.prototype.toLocalFromUTC = function () {
    return new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate(),  this.getHours(), this.getMinutes(), this.getSeconds()));
}

Date.prototype.toUTCFromLocal = function () {
    return new Date(this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate(),  this.getUTCHours(), this.getUTCMinutes(), this.getUTCSeconds());
}

export {}